<template>
    <v-row>
      <!-- Documentos -->
      <v-col cols="12" md="6">
        <v-card
          :loading="!documentos_cargados"
          >
          <v-card-text>
            <p>
              <v-icon>mdi-draw</v-icon>
              Documentos pendientes de firma
            </p>
            <p class="display-2 text-center mb-0">
              {{obj.documentos_pendiente_firma.length}}
            </p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn icon @click="showDoc = !showDoc">
              <v-icon>{{ showDoc ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
            </v-btn>
          </v-card-actions>
          <div v-show="showDoc">
            <v-divider></v-divider>
            <v-list 
              dense
              v-if="obj.documentos_pendiente_firma.length > 0 && documentos_cargados"
              >
              <v-list-item
                v-for="(item_, i) in obj.documentos_pendiente_firma"
                :key="i"
                >
                <v-list-item-content>
                  <v-list-item-title v-text="item_.nombre"></v-list-item-title>
                  <v-list-item-subtitle v-text="item_.fecha_carga"></v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn 
                    fab x-small 
                    class="mx-2" 
                    title="Firmar"
                    :to="{ name: 'documento_edit', params: {opt: 'firmar', id: item_.id}}">
                    <v-icon>mdi-draw</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </div>
        </v-card>
      </v-col>
      <!-- Lotes -->
      <v-col cols="12" md="6">
        <v-card
          :loading="!documentos_cargados"
          >
          <v-card-text>
            <p>
              <v-icon>mdi-draw</v-icon>
              Lotes pendientes de firma
            </p>
            <p class="display-2 text-center mb-0">
              {{obj.lotes_pendientes_firma.length}}
            </p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn icon @click="showLotes = !showLotes">
              <v-icon>{{ showLotes ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
            </v-btn>
          </v-card-actions>
          <div v-show="showLotes">
            <v-divider></v-divider>
            <v-list 
              dense
              v-if="obj.lotes_pendientes_firma.length > 0 && documentos_cargados"
              >
              <v-list-item
                v-for="(lote_, ii) in obj.lotes_pendientes_firma"
                :key="ii"
                >
                <v-list-item-content>
                  <v-list-item-title v-text="lote_.nombre"></v-list-item-title>
                  <v-list-item-subtitle v-text="lote_.fecha_carga"></v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn 
                    fab x-small 
                    class="mx-2" 
                    title="Lotes"
                    @click="detalleLote(lote_)">
                    <v-icon>mdi-eye-check-outline</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </div>
        </v-card>
      </v-col>
    </v-row>
</template>

<script>
import axios from "axios";

export default {
  data: function() {
    return {
      showDoc: false,
      showLotes: false,
      documentos_cargados: false,
      obj: {
        "documentos_pendiente_firma": [],
        "lotes_pendientes_firma": [],
      },
    };
  },
  computed: {
    
  },
  watch: {
    
  },
  created () {
    this.getEstadisticas();
  },
  mounted() {

  },
  methods: {
    getEstadisticas() {
      let getRubricas = axios.get('Dashboard/estadisticas', { 'headers': this.$store.state.user.headers });
      return getRubricas.then((callback) =>
      {
        if(callback.status == 200){
          this.obj = callback.data;
          this.documentos_cargados = true;
        } else {
          this.$store.dispatch('SHOW_ERROR', {show: true, type: 'error', text: 'Hubo un error en la carga.' });
        }
      }).catch((error) => {
        console.log("ERROR EN EL CALLBACK" + error);
      });
    },
    detalleLote(item){
      //console.log(item);
      this.$store.state.user.lote_seleccionado = item;
      this.$router.push({name: 'lote_documentos', params: {'id': item.id}});
    },
  },
};
</script>